import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withCtx as _withCtx, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  id: "kt_account_profile_details",
  class: "collapse show"
}
const _hoisted_3 = { class: "card-body border-top p-9" }
const _hoisted_4 = { class: "row mb-6" }
const _hoisted_5 = { class: "col-lg-6 fv-row" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Tim Area", -1)
const _hoisted_7 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_8 = { class: "fv-help-block" }
const _hoisted_9 = { class: "col-lg-6 fv-row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label fw-bold fs-6" }, "Keterangan", -1)
const _hoisted_11 = { class: "row mb-6" }
const _hoisted_12 = { class: "col-lg-6 fv-row" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("label", { class: "col-lg-4 col-form-label required fw-bold fs-6" }, "Sales Leader", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sales Leader", -1)
const _hoisted_15 = ["label", "value"]
const _hoisted_16 = {
  key: 0,
  class: "fv-plugins-message-container"
}
const _hoisted_17 = { class: "fv-help-block" }
const _hoisted_18 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_19 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_1"
}
const _hoisted_20 = { class: "modal-dialog" }
const _hoisted_21 = { class: "modal-content" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Tambah Wilayah"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_23 = { class: "modal-body" }
const _hoisted_24 = { class: "col-xl-12" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Provinsi", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Provinsi", -1)
const _hoisted_27 = ["label", "value"]
const _hoisted_28 = { class: "modal-footer" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_30 = {
  class: "modal fade",
  tabindex: "-1",
  id: "kt_modal_2"
}
const _hoisted_31 = { class: "modal-dialog" }
const _hoisted_32 = { class: "modal-content" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "modal-header" }, [
  /*#__PURE__*/_createElementVNode("h5", { class: "modal-title" }, "Tambah Sales"),
  /*#__PURE__*/_createElementVNode("div", {
    class: "btn btn-icon btn-sm btn-active-light-primary ms-2",
    "data-bs-dismiss": "modal",
    "aria-label": "Close"
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-2x" })
  ])
], -1)
const _hoisted_34 = { class: "modal-body" }
const _hoisted_35 = { class: "col-xl-12" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("label", { class: "form-label fw-bolder text-dark fs-6" }, "Sales Area", -1)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("option", {
  value: "",
  disabled: ""
}, "Pilih Sales Area", -1)
const _hoisted_38 = ["label", "value"]
const _hoisted_39 = { class: "modal-footer" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("button", {
  type: "button",
  class: "btn btn-light",
  "data-bs-dismiss": "modal"
}, " Batal ", -1)
const _hoisted_41 = { class: "card-body py-3" }
const _hoisted_42 = { class: "table-responsive" }
const _hoisted_43 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"70%"},
      class: "text-center"
    }, "Nama Sales"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"30%"},
      class: "text-center"
    }, "Aksi")
  ])
], -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = { class: "text-center" }
const _hoisted_47 = { class: "text-center" }
const _hoisted_48 = ["onClick"]
const _hoisted_49 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_50 = [
  _hoisted_49
]
const _hoisted_51 = { key: 1 }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_53 = [
  _hoisted_52
]
const _hoisted_54 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_55 = { class: "fv-help-block" }
const _hoisted_56 = { class: "card-body py-3" }
const _hoisted_57 = { class: "table-responsive" }
const _hoisted_58 = { class: "table align-middle gs-0 gy-4" }
const _hoisted_59 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", { class: "fw-bolder text-muted bg-light" }, [
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"70%"},
      class: "text-center"
    }, "Provinsi"),
    /*#__PURE__*/_createElementVNode("th", {
      style: {"width":"30%"},
      class: "text-center"
    }, "Aksi")
  ])
], -1)
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { class: "text-center" }
const _hoisted_62 = { class: "text-center" }
const _hoisted_63 = ["onClick"]
const _hoisted_64 = /*#__PURE__*/_createElementVNode("img", {
  src: "/media/icons/delete.svg",
  alt: ""
}, null, -1)
const _hoisted_65 = [
  _hoisted_64
]
const _hoisted_66 = { key: 1 }
const _hoisted_67 = /*#__PURE__*/_createElementVNode("tr", null, [
  /*#__PURE__*/_createElementVNode("td", {
    colspan: "7",
    style: {"text-align":"center"}
  }, "Tidak Ada Data")
], -1)
const _hoisted_68 = [
  _hoisted_67
]
const _hoisted_69 = {
  key: 2,
  class: "fv-plugins-message-container"
}
const _hoisted_70 = { class: "fv-help-block" }
const _hoisted_71 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-label" }, " Simpan ", -1)
const _hoisted_74 = /*#__PURE__*/_createElementVNode("span", { class: "indicator-progress" }, [
  /*#__PURE__*/_createTextVNode(" Silahkan Tunggu ... "),
  /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" })
], -1)
const _hoisted_75 = [
  _hoisted_73,
  _hoisted_74
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        id: "kt_account_profile_details_form",
        class: "form",
        novalidate: "novalidate",
        onSubmit: _cache[10] || (_cache[10] = ($event: any) => (_ctx.saveChanges1()))
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "name",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Tim Area",
                  modelValue: _ctx.tambah.name,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.tambah.name) = $event))
                }, null, 8, ["modelValue"]),
                (_ctx.tambah.name == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, _toDisplayString(_ctx.items.errorName), 1)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _createVNode(_component_Field, {
                  type: "text",
                  name: "note",
                  class: "form-control form-control-lg",
                  placeholder: "Isi Keterangan",
                  modelValue: _ctx.tambah.note,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.tambah.note) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_Field, {
                  as: "select",
                  class: "form-select form-select-lg fw-bold",
                  name: "salesLeader",
                  autocomplete: "off",
                  modelValue: _ctx.tambah.salesLeadersSelect,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.tambah.salesLeadersSelect) = $event))
                }, {
                  default: _withCtx(() => [
                    _hoisted_14,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.salesLeaders, (option) => {
                      return (_openBlock(), _createElementBlock("option", {
                        key: option._id,
                        label: option.name,
                        value: option._id
                      }, null, 8, _hoisted_15))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                (_ctx.tambah.salesLeadersSelect == '')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.items.errorLeader), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("button", {
              class: "btn btn-sm btn-warning me-3",
              type: "button",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_1",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.addAreaModal && _ctx.addAreaModal(...args)))
            }, " Tambah Wilayah "),
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _createElementVNode("div", _hoisted_21, [
                  _hoisted_22,
                  _createElementVNode("div", _hoisted_23, [
                    _createElementVNode("div", _hoisted_24, [
                      _hoisted_25,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "regions",
                        autocomplete: "off",
                        modelValue: _ctx.items.regions,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.items.regions) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.provinsiOptions, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option.id,
                              label: option.name,
                              value: option.name
                            }, null, 8, _hoisted_27))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_28, [
                    _hoisted_29,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.submitAddProvince())),
                      "data-bs-dismiss": "modal"
                    }, " Simpan ")
                  ])
                ])
              ])
            ]),
            _createElementVNode("button", {
              class: "btn btn-primary me-3",
              type: "button",
              "data-bs-toggle": "modal",
              "data-bs-target": "#kt_modal_2",
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.addSalesModal && _ctx.addSalesModal(...args)))
            }, " Tambah Sales "),
            _createElementVNode("div", _hoisted_30, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("div", _hoisted_34, [
                    _createElementVNode("div", _hoisted_35, [
                      _hoisted_36,
                      _createVNode(_component_Field, {
                        as: "select",
                        class: "form-select form-select-lg fw-bold",
                        name: "member",
                        autocomplete: "off",
                        modelValue: _ctx.items.members,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.items.members) = $event))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_37,
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.items.user_sales_area, (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              key: option._id,
                              label: option.name,
                              value: option.name
                            }, null, 8, _hoisted_38))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_39, [
                    _hoisted_40,
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-primary",
                      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.submitAddSales())),
                      "data-bs-dismiss": "modal"
                    }, " Simpan ")
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_41, [
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("table", _hoisted_43, [
                _hoisted_44,
                (_ctx.tambah.members.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_45, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tambah.members, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_46, _toDisplayString(item.salesName), 1),
                          _createElementVNode("td", _hoisted_47, [
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete2(item))
                            }, _hoisted_50, 8, _hoisted_48)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_51, _hoisted_53)),
                (!_ctx.tambah.members.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_54, [
                      _createElementVNode("div", _hoisted_55, _toDisplayString(_ctx.items.errorMember), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_56, [
            _createElementVNode("div", _hoisted_57, [
              _createElementVNode("table", _hoisted_58, [
                _hoisted_59,
                (_ctx.tambah.regions.length)
                  ? (_openBlock(), _createElementBlock("tbody", _hoisted_60, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tambah.regions, (item, index) => {
                        return (_openBlock(), _createElementBlock("tr", { key: index }, [
                          _createElementVNode("td", _hoisted_61, _toDisplayString(item), 1),
                          _createElementVNode("td", _hoisted_62, [
                            _createElementVNode("a", {
                              class: "symbol symbol-35px me-2",
                              "data-bs-toggle": "tooltip",
                              title: "Hapus",
                              style: {"cursor":"pointer"},
                              onClick: ($event: any) => (_ctx.handleDelete(index, item))
                            }, _hoisted_65, 8, _hoisted_63)
                          ])
                        ]))
                      }), 128))
                    ]))
                  : (_openBlock(), _createElementBlock("tbody", _hoisted_66, _hoisted_68)),
                (!_ctx.tambah.regions.length)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_69, [
                      _createElementVNode("div", _hoisted_70, _toDisplayString(_ctx.items.errorRegion), 1)
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_71, [
            _createElementVNode("button", {
              class: "btn btn-danger me-3",
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$router.push('/superadmin/sales/sales-area/')))
            }, " Batal "),
            _createElementVNode("button", {
              type: "submit",
              id: "kt_account_profile_details_submit",
              ref: "submitButton",
              class: "btn btn-primary",
              disabled: _ctx.items.disableButton
            }, _hoisted_75, 8, _hoisted_72)
          ])
        ]),
        _: 1
      })
    ])
  ]))
}